export default {
  newConversationTitle: '!A new story begins!',
  newConversationDescription: 'You are about to send your first message through Whatsapp Business API. Please be kind and don\'t spam.',
  messageHere: 'your message here ',
  moreTemplates: 'See more templates',
  sendTemplate: 'All ok, let\'s go!',
  templateSelectorTitle: 'To start or resume a conversation through Whatsapp, it is necessary to use an approved template',
  templateSelectorDescription: 'To start or resume a conversation is necessary to make it through a template approved by WhatsApp, here you can choose one of the templates that we have for you',
  noTemplatesFound: 'No templates found',
  templatesSearchPlaceholder: 'Search templates',
  errorSendingTemplate: 'An error occurred while sending the template',
  templateSent: 'Template sent',
  providerSelector: 'You have several active lines, choose from which one you want to send your message',
  noLines: 'Your WhatsApp is not connected, so you can\'t send messages. \n Click below to contact a support agent.',
  getSupport: 'Get support',
  phonePlaceholder: 'Enter a phone number',
  invalidPhone: 'Invalid phone number',
  validPhone: 'Valid phone number',
  errorGettingTemplates: 'An error occurred while getting the templates',
  customTextField: 'Custom text field',
  startInternalChat: 'Start an internal conversation',
  emptyUserList: 'Must indicate the users',
  newWhatsappMessage: 'New whatsApp message',
  newInternalMessage: 'New internal message',
  newInternalGroup: 'New internal group',
  searchForSomeoneInYourTeam: 'Search for someone in your team',
  groupName: 'Group name',
  advisorsSelected: 'users selected',
  team: 'Team',
  addOrRemovePeopleFromConversation: 'Add or remove users from this conversation',
  addMorePeople: 'Add more people',
  editGroupName: 'Edit internal group name',
  leaveNameEmptyToNameGroup: 'You can leave it empty to name automatically',
  bussinessAccount: 'Business account',
  newConversation: 'New Message',
  addAnUrl: '/Add an url',
  addMediaUrl: 'Add an attached file',
  IMAGE: 'Image',
  VIDEO: 'Video',
  DOCUMENT: 'Document',
  check: 'Check'
}
